import ajax from '@/utils/ajax'
export default {
  // 获取列表数据
  getPageList(data) {
    return ajax({
      url: 'gt6/analysisReport/getPageList',
      method: 'POST',
      data
    })
  },
  // 获取可下载分析报告数 /api/gt/analysisReport/getInfo
  getInfo(params) {
    return ajax({
      url: 'gt6/analysisReport/getInfo',
      method: 'GET',
      params
    })
  },
  // 开通报告接口 gt/analysisReport/reportOpen
  reportOpen(params) {
    return ajax({
      url: 'gt6/analysisReport/reportOpen',
      method: 'GET',
      params
    })
  },
  // 获取开通报告信息 /api/gt/analysisReport/getReportOpenInfo
  getReportOpenInfo(params) {
    return ajax({
      url: 'gt6/analysisReport/getReportOpenInfo',
      method: 'GET',
      params
    })
  },
  // 文件下载 analysisReport/downloadAnalysisReport
  downloadAnalysisReport(data) {
    return ajax({
      url: 'gt6/search/downloadAnalysisReport',
      method: 'POST',
      responseType: 'blob',
      data
    })
  },
  // 详情 gt/analysisReport/getDetail
  getDetail(params) {
    return ajax({
      url: 'gt6/analysisReport/getDetail',
      method: 'GET',
      params
    })
  },
  // pdf文件预览api/gt/analysisReport/reportPreview
  reportPreview(data) {
    return ajax({
      url: 'gt6/analysisReport/reportPreview',
      responseType:"arraybuffer",
      method: 'POST',
      data
    })
  },
  // 获取标签数据接口 /analysisReport/getLabels
  getLabels(params) {
    return ajax({
      url: 'gt6/analysisReport/getLabels',
      method: 'GET',
      params
    })
  },
  //获取行业分类
  getIndustrys(params) {
    return ajax({
      url: 'gt6/analysisReport/getIndustrys',
      method: 'GET',
      params
    })
  },
  // 获取报告语言种类
  getReportLanuage(params) {
    return ajax({
      url: 'gt6/analysisReport/getReportLanuage',
      method: 'GET',
      params
    })
  },
}